











import { Vue, Component, Prop } from "vue-property-decorator";

import ModalComponent from "@service/components/modal/ModalComponent.vue";
import BackgroundSelect from "@share/web-conferences/components/background-select/BackgroundSelect.vue";
import { VirtualBackgroundEffectOptions } from "agora-extension-virtual-background";

@Component({ components: { ModalComponent, BackgroundSelect } })

export default class BackgroundSelectModal extends Vue {
    @Prop() backgroundEffect: VirtualBackgroundEffectOptions | null;
}

